import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'

import DomClass from './../../../../../../../js/classes/Dom.js'

import Location from './Location.jsx'
import Search from './Search.jsx'

const SelectLocation = ({ isShow, setShow, locations, handleSetCurrentTown }) => {
    if (isShow) {
        const handleClose = () => {
            setShow(false)
        }

        useEffect(() => {
            DomClass.setCenter('.happy-select-location__popup-inner')
        }, [])

        return <div className="happy-select-location__popup">
            <div className="happy-select-location__popup-blackmask" onClick={ handleClose }></div>
            <div className="happy-select-location__popup-inner">
                <span className="happy-select-location__close" onClick={ handleClose }></span>

                <div className="happy-select-location__title">
                    Выберите свой город
                </div>

                <Search handleSetCurrentTown={ handleSetCurrentTown } />

                <div className="happy-select-location__list">
                    { locations.map((location) => {
                        return <Location
                            key={ `location-${ location.ID }` }
                            location={ location }
                            handleSetCurrentTown={ handleSetCurrentTown }
                        />
                    }) }
                </div>
            </div>
        </div>
    } else {
        return null
    }
}

export default SelectLocation